
// This is an auto generated file - do not edit!
// Swagger path: /api/Import/types

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    ImportCategory
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class ImportTypesApiService extends BaseApiService {
    
    get(options = {}): Observable<ImportCategory[]> {
        return this._get<ImportCategory[]>(
            `/Import/types`,
            options
        );
    }
}
